var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#464655"
    },
    width: 512,
    height: 85.33
  }), /*#__PURE__*/React.createElement("rect", {
    y: 85.33,
    style: {
      fill: "#FFE15A"
    },
    width: 512,
    height: 85.33
  }), /*#__PURE__*/React.createElement("rect", {
    y: 170.67,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 85.33
  }), /*#__PURE__*/React.createElement("rect", {
    y: 256,
    style: {
      fill: "#464655"
    },
    width: 512,
    height: 85.33
  }), /*#__PURE__*/React.createElement("rect", {
    y: 341.33,
    style: {
      fill: "#FFE15A"
    },
    width: 512,
    height: 85.33
  }), /*#__PURE__*/React.createElement("rect", {
    y: 426.67,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 85.33
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F5F5F5"
    },
    cx: 256,
    cy: 256,
    r: 80.84
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M260.876,206.78l7.964-3.185c1.154-0.462,1.712-1.785,1.201-2.917  c-1.786-3.96-6.571-12.153-15.665-12.399c-5.759-0.156-10.064,1.142-12.494,2.144c-1.241,0.512-1.74,1.989-1.062,3.148l4.806,8.21  L260.876,206.78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M254.375,188.278c-0.662-0.018-1.26,0.021-1.883,0.039l-0.867,12.713l4.625,2.563l10.004-9.051  C263.619,191.353,259.757,188.423,254.375,188.278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M288.629,281.538l-36.004-42.005c0-8.694,3.142-15.793,4.877-19.057  c4.956-2.213,8.151-7.663,6.822-13.679c-0.967-4.375-4.498-7.946-8.866-8.945c-7.859-1.797-14.834,4.125-14.834,11.677  c0,0.284,0.064,0.551,0.084,0.83c-7.766,2.048-9.21,4.546-9.21,4.546s5.09-1.354,9.508-2.511c0.089,0.36,0.207,0.708,0.327,1.055  l-8.71,2.957l9.512-1.158c1.056,1.932,2.623,3.539,4.513,4.649c-7.109,5.727-18.025,16.489-18.025,28.638  c0,11.109,8.229,18.511,18.591,23.433c3.622,1.721,6.953,3.992,9.691,6.922l0.102,0.109l0.902,13.791c-7.432,0-16.293,0-20.285,0  c-7.501,0-9.564,4.876-9.564,12.939l3.563-5.063l3,5.626l0.375-6.376l3.188,4.125c0,0-0.033-5.388,4.032-6.094  c2.156-0.375,9.628-0.844,15.972-0.844l1.344,20.551c-8.606-0.041-18.348,4.014-18.348,4.014c3-0.563,10.314,0.563,10.314,0.563  l-1.219,3.563c8.438-4.594,23.909-4.688,23.909-4.688s-3.375-2.302-11.251-3.203l0.182-20.8h12.381l1.875-4.876  c0,0-6.389-8.474-6.389-12.964C280.893,281.143,288.629,281.538,288.629,281.538z M263.159,292.789l0.062-7.135  c3.717,3.983,6.655,7.135,6.655,7.135S267.102,292.789,263.159,292.789z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#696E7D"
    },
    d: "M288.629,287.539c-3-12.001-16.149-15.69-30.003-24.003c-15.002-9.001-6.001-24.003-6.001-24.003  s50.255,14.752,54.006,36.004c2.921,16.551-9.001,27.003-15.002,30.003l2.156-6.001h-11.157c0,0,11.814-9.188,12.001-18.002  L288.629,287.539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFCFF"
    },
    d: "M306.631,275.538c-2.507-14.207-25.784-25.501-40.95-31.433l0,0  c-4.853-0.54-9.118,7.618,4.196,16.431c17.911,11.857,18.752,27.003,18.752,27.003l6.001-6.001  c-0.188,8.813-12.001,18.002-12.001,18.002h11.157l-2.156,6.001C297.63,302.541,309.552,292.088,306.631,275.538z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M306.631,275.538c-1.662-9.416-12.452-17.54-23.953-23.684c-5.539-1.656-10.363-1.444-10.363-1.444  c3.375,2.063,4.876,7.313,4.876,7.313c-2.438-1.5-7.876-0.75-7.876-0.75c1.512,1.297,2.946,3.942,3.904,5.968  c14.667,11.401,15.411,24.597,15.411,24.597l6.001-6.001c-0.188,8.813-12.001,18.002-12.001,18.002h11.157l-2.156,6.001  C297.63,302.541,309.552,292.088,306.631,275.538z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F5F5F5"
    },
    cx: 247.75,
    cy: 208.41,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M242.499,216.031c0,0-4.375,5.126-1.5,6.626s5.649-2.76,5.649-2.76L242.499,216.031z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUg);
export default __webpack_public_path__ + "static/media/UG.18a329db789e02e58182ae1566f60dda.svg";
export { ForwardRef as ReactComponent };